// @flow
import React from 'react';
import onClickOutside from 'react-onclickoutside';
import Timekeeper from 'react-timekeeper';
import styles from './timeCell.css';

export type ClockPropTypes = {
  time: string,
  onDoneClick: Function,
  onClickOutsideHandler: Function,
  onChange?: Function,
};

class Clock extends React.Component<ClockPropTypes, > {
  handleClickOutside = () => {
    const { onClickOutsideHandler } = this.props;
    if (onClickOutsideHandler) {
      onClickOutsideHandler();
    }
  };

  render() {
    const { time, onDoneClick, onChange } = this.props;
    return (
      <div className={styles.clockContainer}>
        <Timekeeper
          time={time}
          onChange={onChange}
          onDoneClick={onDoneClick}
          switchToMinuteOnHourSelect
        />
      </div>
    );
  }
}

export default onClickOutside(Clock);



// WEBPACK FOOTER //
// ./src/scripts/components/DataTable/Cells/Time/clock.jsx